export const mediaQueries = {
  xs: 0,
  sm: 577,
  md: 769,
  lg: 993,
  xl: 1201,
};
